import { Grid, styled } from '@mui/material';
import React, { Fragment } from 'react';
import RowCards from './shared/RowCards';
import StatCards from './shared/StatCards';
import StatCards2 from './shared/StatCards2';
import TopSellingTable from './shared/TopSellingTable';
import AdminLogsTable from './shared/AdminLogsTable';
import UpgradeCard from './shared/UpgradeCard';
import OrderStatictics from './shared/OrderStatictics';
import CustomerStates from './shared/CustomerStates';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' },
}));


const H4 = styled('h4')(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: '500',
  marginBottom: '16px',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
}));

const Analytics = () => {
  // let { dashboard_data } = useDashboard();
  var dashboard_data = undefined;

  if (dashboard_data === undefined) {
    dashboard_data = {
      topCards: {
        active_products: 1,
        total_sale: 1,
        completed_orders: 1,
        orders_to_deliver: 1
      },
      top_Selling_areas: [],
      vendors: [],
      bottomCards: {
        active_users: 0,
        active_sellers: 0,
      },
      top_selling_products: [],
      feature_products: []
    }
  };




  return (
    <Fragment>
      <ContentBox className="analytics">
        <Grid container spacing={3}>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <OrderStatictics key={'order-statictics'} />
            <StatCards dashboard_data={dashboard_data?.topCards} />
            <TopSellingTable top_Selling_prodiucts={dashboard_data?.top_selling_products} />
            <AdminLogsTable />
            {/* <ReviewTable /> */}

            {/* {dashboard_data?.feature_products && <H4>Featured Products</H4>}
            <RowCards feature_products_list={dashboard_data?.feature_products} /> */}

          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <CustomerStates />
            <UpgradeCard vendors={dashboard_data?.vendors} />
            <StatCards2 dashboard_data={dashboard_data?.bottomCards} />
          </Grid>

        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default Analytics;
